'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dHost$0024 from "./presto.types$-Host$.js";
import * as $j_presto$002etypes$0024$002dRestricted$002dDomain$002dId$0024 from "./presto.types$-Restricted-Domain-Id$.js";
import * as $j_presto$002etypes$0024$002dRestricted$002dDomain$002dName$0024 from "./presto.types$-Restricted-Domain-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_Domains$$anon$3(outer) {
  this.aOz = null;
  this.aOx = null;
  this.aOy = false;
  this.aOv = null;
  this.aOw = false;
  this.aOA = false;
  this.aOB = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aOz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Domains$$anon$3 as $c_Lpresto_Domains$$anon$3 };
$p = $c_Lpresto_Domains$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Domains$$anon$3;
/** @constructor */
function $h_Lpresto_Domains$$anon$3() {
}
export { $h_Lpresto_Domains$$anon$3 as $h_Lpresto_Domains$$anon$3 };
$h_Lpresto_Domains$$anon$3.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.aOz;
});
$p.t = (function() {
  if ((!this.aOy)) {
    this.aOx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("host", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("global", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aOy = true;
  }
  return this.aOx;
});
$p.ad = (function() {
  if ((!this.aOw)) {
    this.aOv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dRestricted$002dDomain$002dId$0024.$m_Lpresto_types$RestrictedDomainId$().Gu()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dHost$0024.$m_Lpresto_types$Host$().crA(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dRestricted$002dDomain$002dName$0024.$m_Lpresto_types$RestrictedDomainName$().cHE()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aOw = true;
  }
  return this.aOv;
});
$p.v = (function() {
  if ((!this.aOB)) {
    this.aOA = false;
    this.aOB = true;
  }
  return this.aOA;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Domains$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Domains$$anon$3, "presto.Domains$$anon$3", ({
  HX: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Domains$$anon$3 as $d_Lpresto_Domains$$anon$3 };
//# sourceMappingURL=presto.-Domains$$anon$3.js.map
